import { ProjectMemberDTO } from '../models/project-member.model';
import { PersonOption } from '../components/person-select/person-select.component';

/**
 * Turns project members into reviewer/owner candidates for `app-person-select` (NEX-822).
 *
 * `ProjectMemberDTO.id` is the *membership* id, not the user id — the user id lives in
 * `tenantUserId`, which is `null` while an invite is still `PENDING`. Those rows are
 * filtered out here rather than surfaced as a selectable-but-unusable option. Deactivated
 * memberships (`active: false`) are excluded for the same reason.
 */
export function reviewerOptionsFromMembers(members: ProjectMemberDTO[]): PersonOption[] {
  return members
    .filter((m) => m.active && !!m.tenantUserId)
    .map((m) => ({
      id: m.tenantUserId as string,
      displayName: [m.firstName, m.lastName].filter(Boolean).join(' ').trim() || m.email,
    }));
}
